module.exports = __webpack_public_path__ + "img/10979914_L.2afc5cc6.png";